<template>
  <div class="triggerList">
    <div class="content-view" v-if="triggerList.length">
      <div class="top-view">
        <div class="div">
          <div class="txt">触发条件：</div>
          <el-radio-group v-model="radio" @change="radiochange">
            <el-radio label="1">满足以下所有条件</el-radio>
            <el-radio label="0">满足以下任意条件</el-radio>
          </el-radio-group>
        </div>
        <div class="ad-btn" @click="dialogVisibleOpen(0)">+添加触发条件</div>
      </div>
      <div class="bot-view">
        <table class="table-box" border="1">
          <tr v-for="(item, index) in triggerList" :key="index">
            <td class="type">{{ backdictLabel(item.operateType) }}</td>
            <td class="name">{{ item.propertyName }}</td>
            <td class="btnview">
              <div class="txt" @click="dialogVisibleOpen(1, item)">编辑</div>
              <div class="txt red" @click="deltriggerList(item, index)">删除</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class=" content-view-no" v-else>
      <div class="btn" @click="dialogVisibleOpen(0)">+添加触发条件</div>
    </div>
    <!-- 新增触发条件 -->
    <el-dialog :title="dialogVisibleType == 'add' ? '新增触发条件' : '编辑触发条件'" custom-class="addtriggerdialog" append-to-body
      :visible.sync="dialogVisible" width="30%">
      <div class="form-view">
        <div class="top">
          <div class="name">触发条件</div>
          <div class="sel-view">
            <el-select v-model="value" placeholder="请选择" @change="triggerTypeChange">
              <el-option v-for="item in triggerTypeList" :key="item.dictValue" :label="item.dictLabel"
                :value="item.dictValue">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="bottom bottom-cgq" v-if="value == '0'">
          <div class="left-view">
            <div class="header-view">
              <el-input v-model="deviceName" placeholder="请输入产品名称">
                <i @click.stop="seachdeviceTree" slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="tree-view">
              <el-tree :data="deviceTree" node-key="id" :default-expanded-keys="expandedKeys" :props="defaultProps"
                @node-click="handleNodeClick">
                <template #default="{ node, data }">
                  <span class="custom-tree-node">
                    <span class="changespan" v-if="data.dataItemCode">
                      {{ data.label }}
                      <div class="yuan" :class="{ 'yuan-ed': cgqActiveValue.id == data.id }"></div>
                    </span>
                    <span v-else>{{ data.label }}</span>
                  </span>
                </template>
              </el-tree>
            </div>
          </div>
          <div class="icon-jt"></div>
          <div class="right-view">
            <div class="view">
              <div class="header-view" @click="cgqValueTypeChange('up')">
                <div class="title">高于上限</div>
                <div class="yuan " :class="{ 'yuan-ed': cgqValueType == 'up' }"></div>
              </div>
              <div class="con-view">
                <div class="label">高于上限值<template v-if="cgqActiveValue && cgqActiveValue.unitName">({{
      cgqActiveValue.unitName }})</template></div>
                <div class="input">
                  <el-input v-model="cgqupValue" placeholder="请输入"></el-input>
                </div>
              </div>
            </div>
            <div class="view">
              <div class="header-view" @click="cgqValueTypeChange('down')">
                <div class="title">低于下限</div>
                <div class="yuan " :class="{ 'yuan-ed': cgqValueType == 'down' }"></div>
              </div>
              <div class="con-view">
                <div class="label">低于上限值<template v-if="cgqActiveValue && cgqActiveValue.unitName">({{
      cgqActiveValue.unitName }})</template></div>
                <div class="input">
                  <el-input v-model="cgqdownValue" placeholder="请输入"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom bottom-ds" v-if="value == '1'">
          <div class="header-view">
            <div class="label">时间选择：</div>
            <div class="sel">
              <el-time-picker v-model="timeValue" format="HH:mm" placeholder="任意时间点" value-format="HH:mm">
              </el-time-picker>
            </div>
          </div>
          <div class="cont-view">
            <div class="con">
              <div class="timingtypeList">
                <div class="item" v-for="(item, index) in timingTypeList" :key="index"
                  @click="timingtypeClick(item.dictValue)">
                  <div class="label">{{ item.dictLabel }}</div>
                  <div class="yuan" :class="{ 'yuan-ed': item.dictValue == timingtype }"></div>
                </div>
              </div>
              <div class="weeekList" v-if="timingtype == '4'">
                <div class="item "
                  :class="{ 'item-ed': weektypeArr.includes(item.dictValue), 'item-no': timingtype != '4' }"
                  v-for="(item, index) in weekTypeList" :key="index" @click="weekClick(item.dictValue)">
                  <div class="txt">{{ item.dictLabel }}</div>
                  <div class="r-g">
                    <img class="icon" src="@/assets/image/cloudscene/mti.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom bottom-kjhj" v-if="value == '2'">
          <div class="left-view">
            <div class="header-view">
              <el-input v-model="deviceName" placeholder="请输入地区搜索">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="tree-view">
              <el-tree :data="deviceTree" :props="defaultProps" @node-click="handleNodeClick">
                <template #default="{ node, data }">
                  <span class="custom-tree-node">
                    <span class="changespan" v-if="data.dataItemCode">
                      {{ data.label }}
                      <div class="yuan" :class="{ 'yuan-ed': cgqActiveValue.id == data.id }"></div>
                    </span>
                    <span v-else>{{ data.label }}</span>
                  </span>
                </template>
              </el-tree>
            </div>
          </div>
          <div class="icon-jt"></div>
          <div class="right-view">
            <div class="header-view">
              <div class="label">空间环境变化</div>
              <div class="sel">
                <el-select v-model="environmentVlaue" placeholder="请选择室外天气环境">
                  <el-option v-for="item in environmentList" :key="item.dictValue" :label="item.dictLabel"
                    :value="item.dictValue">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="con-view" v-if="environmentVlaue != ''">
              <div class="con-view-div"
                v-if="environmentVlaue == '1' || environmentVlaue == '2' || environmentVlaue == '3' || environmentVlaue == '5'">
                <div class="item">
                  <div class="title">
                    <div class="yuan" :class="{ 'yuan-ed': environmentattributeType == 'up' }"
                      @click="enattributeTypeChange('up')"></div>
                    <div class="label">室外温度高于</div>
                  </div>
                  <div class="input">

                    <el-input v-model="enUpValue" placeholder="请输入数值">
                      <span slot="suffix" class="">（{{ activeUnit }}）</span>
                    </el-input>
                  </div>
                </div>
                <div class="item">
                  <div class="title">
                    <div class="yuan" :class="{ 'yuan-ed': environmentattributeType == 'down' }"
                      @click="enattributeTypeChange('down')"></div>
                    <div class="label">室外温度低于</div>
                  </div>
                  <div class="input">

                    <el-input v-model="enDownValue" placeholder="请输入数值">
                      <span slot="suffix" class="">（{{ activeUnit }}）</span>
                    </el-input>
                  </div>
                </div>
              </div>
              <div class="con-view-div noPLR" v-else>
                <div class="li" v-for="(item, index ) in weatherList" :key="index"
                  @click="weatherLiClick(item.dictValue)">
                  <div class="label">{{ item.dictLabel }}</div>
                  <div class="yuan" :class="{ 'yuan-ed': weatherValue == item.dictValue }"></div>
                </div>
              </div>

            </div>
            <div class="con-view con-view-no" v-else>
              <img class="table-noimg" src="@/assets/image/home/ZWT.png" alt="" />
              <div class="table-emptyword">请先选择空间环境变化</div>
            </div>
          </div>
        </div>
        <div class="bottom bottom-gj" v-if="value == '3'">
          <div class="left-view">
            <div class="header-view">
              <el-input v-model="deviceName" placeholder="请输入产品名称">
                <i @click.stop="seachdeviceTree" slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="tree-view">
              <el-tree :data="deviceTree" node-key="id" :default-expanded-keys="expandedKeys" :props="defaultProps"
                @node-click="handleNodeClick">
                <template #default="{ node, data }">
                  <span class="custom-tree-node">
                    <span class="changespan" v-if="data.dataItemCode">
                      {{ data.label }}
                      <div class="yuan" :class="{ 'yuan-ed': cgqActiveValue.id == data.id }"></div>
                    </span>
                    <span v-else>{{ data.label }}</span>
                  </span>
                </template>
              </el-tree>
            </div>
          </div>
          <div class="icon-jt"></div>
          <template v-if="cgqActiveValue.id">
            <div class="gj-view" v-if="warningList.length">
              <div class="li-view" v-for="(item, index) in warningList" :key="index">
                <div class="header-view">
                  <div class="title">{{ item.dataItemName }}</div>
                  <div class="yuan " :class="{ 'yuan-ed': gjIndex == index }"></div>
                </div>
                <div class="info-view">
                  <template v-if="item.alarmUpper">
                    如果【{{ item.dataItemName }}】高于{{ item.alarmUpper }}{{ item.unit }}时，就向手机发送告警消息<br />
                  </template>
                  <template v-if="item.alarmLower">
                    如果【{{ item.dataItemName }}】低于{{ item.alarmLower }}{{ item.unit }}时，就向手机发送告警消息<br />
                  </template>
                </div>
              </div>
            </div>
            <div class="gj-view-no" v-else>
              <img class="table-noimg" src="@/assets/image/home/ZWT.png" alt="" />
              <div class="table-emptyword">暂无告警</div>
            </div>
          </template>
          <template v-else>
            <div class="gj-view-no">
              <img class="table-noimg" src="@/assets/image/home/ZWT.png" alt="" />
              <div class="table-emptyword">请先选择传感器</div>
            </div>

          </template>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="btn-item btn-item2" @click="submitClick">保存</div>
        <div class="btn-item" @click="dialogVisible = false">取消</div>
      </span>
      <Msg ref="tsmsg"></Msg>
    </el-dialog>

  </div>
</template>

<script>
import Msg from '@/components/msg.vue' //信息提示组件
export default {
  components: { Msg },
  props: ["triggerList", "conditionType", "triggerTypeList", "timingTypeList", "weekTypeList"],
  data() {
    return {
      radio: "1",
      // triggerTypeList: [
      //   {
      //     dictLabel: "传感器",
      //     dictValue: "0"
      //   },
      //   {
      //     dictLabel: "定时",
      //     dictValue: "1"
      //   },
      //   {
      //     dictLabel: "空间环境变化",
      //     dictValue: "2"
      //   },
      //   {
      //     dictLabel: "环境告警触发",
      //     dictValue: "3"
      //   }
      // ],
      dialogVisible: false,
      dialogVisibleType: "",
      value: '0',
      deviceName: "",
      deviceTree: [
        // {
        //   "deviceId": "5809",
        //   "productId": "47",
        //   "productType": "6",
        //   "deviceName": "智能开关",
        //   "label": "智能开关",
        //   "deviceNum": "25051402000",
        //   "deviceCompId": "25041701000",
        //   "id": "25041701000",
        //   "children": [
        //     {
        //       "subDeviceNum": "s_0",
        //       "subDeviceName": "温湿度传感",
        //       "label": "温湿度传感",
        //       "subDeviceType": "1-1",
        //       "sort": "2",
        //       "id": "25041701000$s_0",
        //       "children": [
        //         {
        //           "id": "25041701000$s_0$WD",
        //           "dataItemCode": "WD",
        //           "thirdParty": "temperature",
        //           "dataItemName": "温度",
        //           "label": "温度",
        //           "dataItemValue": "",
        //           "sort": "1",
        //           "unitName": "°C",
        //           "method": "r/w"
        //         },
        //         {
        //           "id": "25041701000$s_0$SD",
        //           "dataItemCode": "SD",
        //           "thirdParty": "humidity",
        //           "dataItemName": "湿度",
        //           "label": "湿度",
        //           "dataItemValue": "",
        //           "sort": "8",
        //           "unitName": "%",
        //           "method": "r"
        //         }
        //       ],
        //       "commandsItemList": []
        //     }
        //   ],
        //   "buttonList": [
        //     "controlBtn",
        //     "sensorBtn",
        //     "cameraBtn"
        //   ]
        // },
        // {
        //   "deviceId": "5816",
        //   "productId": "178",
        //   "productType": "6",
        //   "deviceName": "智能双卷被双放风25051404001",
        //   "label": "智能双卷被双放风25051404001",
        //   "deviceNum": "25051404001",
        //   "deviceCompId": "25041702001",
        //   "id": "25051404001",
        //   "children": [
        //     {
        //       "id": "25051404001$s_0",
        //       "subDeviceNum": "s_0",
        //       "subDeviceName": "温湿度传感器",
        //       "label": "温湿度传感器",
        //       "subDeviceType": "1-1",
        //       "subDeviceIcon": "",
        //       "sort": "2",
        //       "children": [
        //         {
        //           "id": "25051404001$s_0$WD",
        //           "dataItemCode": "WD",
        //           "thirdParty": "temperature",
        //           "dataItemName": "温度",
        //           "label": "温度",
        //           "dataItemValue": "",
        //           "sort": "1",
        //           "unitName": "°C",
        //           "appIcon": "a",
        //           "webIcon": "a",
        //           "method": "r/w"
        //         },
        //         {
        //           "id": "25051404001$s_0$SD",
        //           "dataItemCode": "SD",
        //           "thirdParty": "humidity",
        //           "dataItemName": "湿度",
        //           "label": "湿度",
        //           "dataItemValue": "",
        //           "sort": "2",
        //           "unitName": "%",
        //           "appIcon": "a",
        //           "webIcon": "a",
        //           "method": "r"
        //         }
        //       ],
        //       "commandsItemList": []
        //     }
        //   ],
        //   "buttonList": [
        //     "controlBtn",
        //     "sensorBtn",
        //     "eStopBtn",
        //     "cameraBtn"
        //   ]
        // }
      ],
      expandedKeys: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      cgqActiveValue: {

      },
      cgqValueType: "up",//up  down
      cgqupValue: "",//
      cgqdownValue: "",
      timeValue: "",
      // timingtypeList: [
      //   {
      //     dictLabel: "只执行一次",
      //     dictValue: "0"
      //   },
      //   {
      //     dictLabel: "每天",
      //     dictValue: "1"
      //   },
      //   {
      //     dictLabel: "法定工作日",
      //     dictValue: "2"
      //   },
      //   {
      //     dictLabel: "法定节假日",
      //     dictValue: "3"
      //   },
      //   {
      //     dictLabel: "自定义",
      //     dictValue: "4"
      //   }
      // ],
      timingtype: "0",
      // weektypeList: [
      //   {
      //     dictLabel: "周日",
      //     dictValue: "0"
      //   },
      //   {
      //     dictLabel: "周一",
      //     dictValue: "1"
      //   },
      //   {
      //     dictLabel: "周二",
      //     dictValue: "2"
      //   },
      //   {
      //     dictLabel: "周三",
      //     dictValue: "3"
      //   },
      //   {
      //     dictLabel: "周四",
      //     dictValue: "4"
      //   },
      //   {
      //     dictLabel: "周五",
      //     dictValue: "5"
      //   },
      //   {
      //     dictLabel: "周六",
      //     dictValue: "6"
      //   },
      // ],
      weektypeArr: [],
      addressTree: [
        {
          id: "1",
          label: '一级 1',
          children: [
            {
              id: "11",
              label: '二级 1-1',
              children: [{
                id: "111",
                label: '三级 1-1-1'
              }]
            }
          ]
        }
      ],
      addressId: "",
      environmentList: [
        {
          dictLabel: "室外温度",
          dictValue: "1"
        },
        {
          dictLabel: "室外湿度",
          dictValue: "2"
        },
        {
          dictLabel: "PM2.5",
          dictValue: "3"
        },
        {
          dictLabel: "天气",
          dictValue: "4"
        },
        {
          dictLabel: "降雨概率",
          dictValue: "5"
        },
        {
          dictLabel: "日出",
          dictValue: "6"
        },
        {
          dictLabel: "日落",
          dictValue: "7"
        }
      ],
      environmentVlaue: "4",
      environmentattributeType: "up",//up/down
      enUpValue: "",
      enDownValue: "",
      unitList: [
        {
          dictValue: '1',
          unitName: "℃",
        },
        {
          dictValue: '2',
          unitName: "%",
        },
        {
          dictValue: '3',
          unitName: "μg/m³",
        },
        {
          dictValue: '5',
          unitName: "%",
        }
      ],
      weatherList: [
        {
          dictLabel: "晴",
          dictValue: "1"
        },
        {
          dictLabel: "多云",
          dictValue: "2"
        },
        {
          dictLabel: "少云",
          dictValue: "3"
        },
        {
          dictLabel: "晴间多云",
          dictValue: "4"
        },
        {
          dictLabel: "阴",
          dictValue: "5"
        },
        {
          dictLabel: "阵雨",
          dictValue: "6"
        },
        {
          dictLabel: "强阵雨",
          dictValue: "7"
        }
      ],
      weatherValue: "1",
      gjIndex: 0,
      obj: {},
      // 告警列表
      warningList: []
    }
  },
  mounted() {
    this.radio = this.conditionType;
  },
  computed: {
    activeUnit() {
      if (this.environmentVlaue == '') {
        return ""
      } else {
        let arr = this.unitList.filter((item) => {
          return item.dictValue == this.environmentVlaue
        })
        return arr[0].unitName
      }
    }
  },
  methods: {
    radiochange(value) {
      this.$emit("conditionTypeChange", value)
    },
    backdictLabel(operateType) {
      let arr = this.triggerTypeList.filter((item) => {
        if (item.dictValue == operateType) {
          return item
        }
      })
      if (arr.length) {
        return arr[0].dictLabel
      } else {
        return ""
      }
    },
    handleNodeClick(data) {
      console.log(data);
      let arr = data.id.split("$");
      if (arr.length < 3) {
        return
      }
      this.cgqActiveValue = data;
      if (this.value == "3") {
        this.gjIndex = 0
        this.getwarningList();
      }
    },
    // 上限下限切换
    cgqValueTypeChange(type) {
      this.cgqValueType = type
    },
    // 生效时间类型切换
    timingtypeClick(value) {
      this.timingtype = value;
    },
    // 自定义星期选择
    weekClick(value) {
      let bool = this.weektypeArr.indexOf(value) !== -1;
      if (!bool) {
        this.weektypeArr.push(value);
      } else {
        this.weektypeArr.splice(this.weektypeArr.indexOf(value), 1);
      }
    },
    // 触发条件类型改变
    triggerTypeChange() {
      if (this.value == "0") {
        this.value = "0"
        this.cgqActiveValue = {}
        this.cgqValueType = "up"
        this.cgqupValue = ""
        this.cgqdownValue = ""
        this.deviceName = ""
        this.expandedKeys = []
        this.getdeviceTree();
      }
      if (this.value == "1") {
        this.timeValue = ""
        this.timingtype = "0"
        this.weektypeArr = []
      }
      if (this.value == "3") {
        this.deviceName = ""
        this.cgqActiveValue = {}
        this.expandedKeys = []
        this.getdeviceTree();
      }
    },
    // 空间环境数据上下限切换
    enattributeTypeChange(type) {
      this.environmentattributeType = type
    },
    // 空间环境列表类型切换
    weatherLiClick(value) {
      this.weatherValue = value
    },
    // 添加触发弹层打开
    dialogVisibleOpen(type, item) {
      // type 0 新增  1编辑
      this.dialogVisible = true

      if (type == 0) {
        this.dialogVisibleType = "add"
        this.value = "0"
        this.cgqActiveValue = {}
        this.cgqValueType = "up"
        this.cgqupValue = ""
        this.cgqdownValue = ""
        this.deviceName = ""
        this.expandedKeys = []
        this.getdeviceTree();

      } else {
        this.dialogVisibleType = "edit";
        this.value = item.operateType;
        this.obj = JSON.parse(JSON.stringify(item));
        if (this.value == "0") {
          this.cgqActiveValue = {}
          this.cgqValueType = "up"
          this.cgqupValue = ""
          this.cgqdownValue = ""
          this.deviceName = ""
          this.expandedKeys = []
          this.getdeviceTree(item);
        }
        if (this.value == "1") {
          this.timeValue = this.obj.propertyList[0].propertyValue.attributeValue;
          this.timingtype = this.obj.propertyList[0].propertyValue.attributeKey;
          if (this.timingtype == "4") {
            this.weektypeArr = []
            this.obj.propertyList[0].propertyValue.attributeType.split(',').forEach((ele) => {
              this.weektypeArr.push(ele);
            });
          }
          this.$forceUpdate();
        }
        if (this.value == "3") {
          this.deviceName = ""
          this.cgqActiveValue = {}
          this.expandedKeys = []
          this.getdeviceTree(item);
        }
      }
    },

    // 获取传感触发树形列表
    getdeviceTree(Paramsitem) {
      let params = {
        subType: "1",
        deviceName: this.deviceName
      }
      this.$http.postAction(this.$api.userCloudSensorList, params).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            item.label = item.deviceName
            item.id = item.deviceNum;
            if (item.subsetList) {
              item.subsetList.forEach((ele) => {
                ele.label = ele.subDeviceName
                ele.id = item.id + "$" + ele.subDeviceNum;
                if (ele.itemList) {
                  ele.itemList.forEach((a) => {
                    a.label = a.dataItemName;
                    a.id = ele.id + "$" + a.dataItemCode;
                    a.deviceName = item.deviceName
                    a.subDeviceName = ele.subDeviceName
                    a.deviceNum = item.deviceNum
                    a.subDeviceNum = ele.subDeviceNum
                    a.productType = item.productType;
                    a.deviceId = item.deviceId;
                    a.deviceCompId = item.deviceCompId
                    if (Paramsitem) {

                      let deviceNum_ = Paramsitem.propertyList[0].deviceNum
                      let subDeviceNum_ = Paramsitem.propertyList[0].deviceSubNum
                      let dataItemCode_ = Paramsitem.propertyList[0].propertyValue.attributeType


                      if (deviceNum_ == a.deviceNum && subDeviceNum_ == a.subDeviceNum && dataItemCode_ == a.dataItemCode) {
                        this.cgqActiveValue = a;
                        this.cgqValueType = Paramsitem.propertyList[0].propertyValue.attributeKey
                        if (this.cgqValueType == "up") {
                          this.cgqupValue = Paramsitem.propertyList[0].propertyValue.attributeValue
                        } else {
                          this.cgqdownValue = Paramsitem.propertyList[0].propertyValue.attributeValue
                        }
                        this.expandedKeys = [a.id]
                        if (this.value == "3") {
                          this.getwarningList(Paramsitem);
                        }
                      }
                    }
                  })
                  ele.children = ele.itemList
                }
              })
              item.children = item.subsetList
            }
          })
          this.deviceTree = res.data;
          this.$forceUpdate()
        } else {
          this.deviceTree = []
        }

      })
    },
    // 搜索传感触发树形列表
    seachdeviceTree() {
      this.cgqActiveValue = {}
      this.cgqValueType = "up"
      this.cgqupValue = ""
      this.cgqdownValue = ""
      this.getdeviceTree()
    },
    // 获取告警列表
    getwarningList(Paramsitem) {
      let params = {
        deviceNum: this.cgqActiveValue.deviceNum,
        subDeviceNumList: [this.cgqActiveValue.subDeviceNum],
      }
      this.$http.postAction(this.$api.stAlarmConfList, params).then((res) => {
        if (res.data) {
          let arr = [];
          res.data.forEach((item, index) => {
            if (item.alarmUpper || item.alarmLower) {
              if (this.cgqActiveValue.dataItemCode == item.dataItemCode) {
                arr.push(item)

              }
            }
          })
          if (Paramsitem) {
            arr.forEach((item, index) => {
              if (item.dataItemCode == Paramsitem.propertyList[0].propertyValue.attributeType) {
                this.gjIndex = index
              }
            })
            this.$forceUpdate();
          }

          this.warningList = arr;
        }
      })
    },
    isSpotNumber(value) {
      return /^[+-]?\d+$/.test(value);
    },
    // 确定点击
    submitClick() {
      if (this.value == "0") {
        this.cgqSubmit();
      }
      if (this.value == "1") {
        this.dsSubmit();
      }
      if (this.value == "2") {
      }
      if (this.value == "3") {
        this.gjSubmit();
      }
    },
    // 传感触发提交
    cgqSubmit() {
      if (!this.cgqActiveValue.id) {
        this.$refs.tsmsg.msgShow("请选择采集项", 1.5)
        return
      }
      if (this.cgqValueType == "up") {
        if (!this.cgqupValue.length) {
          this.$refs.tsmsg.msgShow("请输入上限值", 1.5)
          return
        }
        if (!this.isSpotNumber(this.cgqupValue)) {
          this.$refs.tsmsg.msgShow('请输入整数');
          return;
        }
      }
      if (this.cgqValueType == "down") {
        if (!this.cgqdownValue.length) {
          this.$refs.tsmsg.msgShow("请输入下限值", 1.5)
          return
        }
        if (!this.isSpotNumber(this.cgqdownValue)) {
          this.$refs.tsmsg.msgShow('请输入整数');
          return;
        }
      }
      let obj = {
        type: this.dialogVisibleType,
        valueType: this.value,
        value: {
          propertyName: '',
          propertyType: 'cloud_scene_trigger',
          operateType: '0',
          productType: '',
          propertyList: [
            {
              propertyKey: '',
              propertyValue: {
                attributeKey: '',
                attributeValue: '',
                attributeType: ''
              },
              deviceNum: '',
              deviceId: '',
              deviceSubNum: '',
              deviceCompNum: '',
              sort: ''
            }
          ]
        }
      }
      if (obj.type == 'edit') {
        obj.value = JSON.parse(JSON.stringify(this.obj));
      }
      let str = '';
      if (this.cgqValueType == "up") {
        str = '升高到' + this.cgqupValue + this.cgqActiveValue.unitName;
        obj.value.propertyList[0].propertyValue.attributeKey = 'up';
        obj.value.propertyList[0].propertyValue.attributeValue = this.cgqupValue;
      } else {
        str = '降低到' + this.cgqdownValue + this.cgqActiveValue.unitName;
        obj.value.propertyList[0].propertyValue.attributeKey = 'down';
        obj.value.propertyList[0].propertyValue.attributeValue = this.cgqdownValue;
      }
      obj.value.propertyName = this.cgqActiveValue.deviceName + this.cgqActiveValue.subDeviceName + this.cgqActiveValue.dataItemName + str;
      obj.value.productType = this.cgqActiveValue.productType;
      obj.value.propertyList[0].propertyKey = '1';
      obj.value.propertyList[0].propertyValue.attributeType = this.cgqActiveValue.dataItemCode;
      obj.value.propertyList[0].deviceNum = this.cgqActiveValue.deviceNum;
      obj.value.propertyList[0].deviceId = this.cgqActiveValue.deviceId;
      obj.value.propertyList[0].deviceCompNum = this.cgqActiveValue.deviceCompId;
      obj.value.propertyList[0].deviceSubNum = this.cgqActiveValue.subDeviceNum;
      obj.value.propertyList[0].sort = '1';
      if (obj.value.propertyName.length > 100) {
        obj.value.propertyName = obj.value.propertyName.slice(0, 100)
      }
      this.$emit("triggerEmitFun", obj)
      this.dialogVisible = false
    },
    // 删除触发条件
    deltriggerList(item, index) {
      this.triggerList.splice(index, 1)
    },
    // 定时提交
    dsSubmit() {
      if (!this.timeValue) {
        this.$refs.tsmsg.msgShow("请选择时间", 1.5)
        return
      }
      if (this.timingtype == "4" && !this.weektypeArr.length) {
        this.$refs.tsmsg.msgShow("请选择自定义星期", 1.5)
        return
      }
      let obj = {
        type: this.dialogVisibleType,
        valueType: this.value,
        value: {
          propertyName: '',
          propertyType: 'cloud_scene_trigger',
          operateType: '1',
          productType: '',
          propertyList: [
            {
              propertyKey: '2',
              propertyValue: {
                attributeKey: '',
                attributeValue: '',
                attributeType: ''
              }
            }
          ]
        }
      };
      if (obj.type == 'edit') {
        obj.value = JSON.parse(JSON.stringify(this.obj));
      }
      obj.value.propertyName = this.timeValue + ' ' + this.timingTypeList[this.timingtype].dictLabel;
      obj.value.propertyList[0].propertyValue.attributeKey = this.timingTypeList[this.timingtype].dictValue;
      obj.value.propertyList[0].propertyValue.attributeValue = this.timeValue;
      obj.value.propertyList[0].sort = '1';
      if (this.timingTypeList[this.timingtype].dictValue == '4') {
        let arr = this.weektypeArr;
        obj.value.propertyList[0].propertyValue.attributeType = arr.join(',');
      }
      let list = this.triggerList.filter((item) => {
        return (item.operateType == '1' && item.propertyList[0].propertyKey == '2');
      });
      let arr = list.filter((item) => {
        let attributeKey = item.propertyList[0].propertyValue.attributeKey;
        let attributeValue = item.propertyList[0].propertyValue.attributeValue;
        let attributeType = item.propertyList[0].propertyValue.attributeType;
        let attributeKey_ = obj.value.propertyList[0].propertyValue.attributeKey;
        let attributeValue_ = obj.value.propertyList[0].propertyValue.attributeValue;
        let attributeType_ = obj.value.propertyList[0].propertyValue.attributeType;
        return (
          attributeKey == attributeKey_ && attributeValue == attributeValue_ && attributeType == attributeType_
        );
      });
      if (arr.length) {
        this.$refs.tsmsg.msgShow("已设置过相同时间", 1.5)
        return
      }
      this.$emit("triggerEmitFun", obj)
      this.dialogVisible = false
    },
    // 告警提交
    gjSubmit() {
      if (!this.warningList.length) {
        this.$refs.tsmsg.msgShow("暂未选择告警", 1.5)
        return
      }
      let obj = {
        type: this.dialogVisibleType,
        valueType: this.value,
        value: {
          propertyName: '',
          propertyType: 'cloud_scene_trigger',
          operateType: '3',
          productType: '',
          propertyList: [
            {
              propertyKey: '5',
              propertyValue: {
                attributeMax: '',
                attributeMin: '',
                attributeType: '',
                attributeId: ""
              },
              deviceNum: '',
              deviceId: '',
              deviceSubNum: '',
              deviceCompNum: '',
            }
          ]
        }
      };
      if (obj.type == 'edit') {
        obj.value = JSON.parse(JSON.stringify(this.obj))
      }
      obj.value.propertyName = `${this.cgqActiveValue.deviceName}触发`
      let item = this.warningList[this.gjIndex]
      if (item.alarmUpper) {
        obj.value.propertyList[0].propertyValue.attributeMax = item.alarmUpper
        obj.value.propertyName += `【${item.dataItemName}】高于${item.alarmUpper + item.unit}时`
      }
      if (item.alarmLower) {
        obj.value.propertyList[0].propertyValue.attributeMin = item.alarmLower
        obj.value.propertyName += `【${item.dataItemName}】低于${item.alarmLower + item.unit}时`
      }
      if (obj.value.propertyName.length > 100) {
        obj.value.propertyName = obj.value.propertyName.slice(0, 100)
      }
      obj.value.propertyList[0].propertyValue.attributeId = item.id;
      obj.value.propertyList[0].propertyValue.attributeType = item.dataItemCode
      obj.value.propertyList[0].deviceNum = this.cgqActiveValue.deviceNum
      obj.value.propertyList[0].deviceId = this.cgqActiveValue.deviceId;
      obj.value.propertyList[0].deviceCompNum = this.cgqActiveValue.deviceCompId;
      obj.value.propertyList[0].deviceSubNum = this.cgqActiveValue.subDeviceNum;
      obj.value.propertyList[0].sort = '1';
      this.$emit("triggerEmitFun", obj)
      this.dialogVisible = false
    }
  },
}
</script>

<style lang="scss" scoped>
.triggerList {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: .275rem;

  .content-view {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .top-view {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .div {
        display: flex;
      }

      .txt {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }

      .ad-btn {
        cursor: pointer;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #2DAEA9;
      }
    }

    .bot-view {
      margin-top: .25rem;
      flex: 1;
      overflow: auto;

      .table-box {
        width: 100%;
        border-color: rgba(241, 241, 241, 1);

        tr {
          td {
            height: .575rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
        }

        .type {
          width: 20%;
        }

        .name {
          width: 60%;
        }

        .btnview {
          width: 20%;

          .txt {
            cursor: pointer;
            display: inline-block;
            margin: 0 .3125rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #2DAEA9;
          }

          .red {
            color: #E33434;
          }
        }
      }
    }
  }

  .content-view-no {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
      cursor: pointer;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #2DAEA9;

    }
  }


}

::v-deep .addtriggerdialog {
  width: 10.45rem !important;
  height: 7.8125rem;
  background: #FFFFFF;
  box-shadow: 0px 0px 1.0125rem 0px rgba(0, 0, 0, 0.18);
  border-radius: .125rem;
  display: flex;
  flex-direction: column;

  .el-dialog__header {
    padding: 0;
    padding-left: .3375rem;
    height: .65rem;
    line-height: .65rem;
    border-bottom: 1px solid #ECECEC;
    ;
  }

  .el-dialog__footer {
    margin-top: 0;
    padding-top: 0;

    .dialog-footer {
      display: flex;
      justify-content: center;

      .btn-item {
        cursor: pointer;
        margin: 0 .0875rem;
        width: 99px;
        height: 36px;
        border-radius: 8px;
        border: 1px solid #2DAEA9;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: .175rem;
        color: #42B5B2;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn-item2 {
        background: #42B5B2;
        color: #FFFFFF;
      }
    }
  }

  .el-dialog__body {
    flex: 1;
    padding-top: .225rem;
    padding-bottom: .35rem;
    padding-left: .5rem;
    padding-right: .425rem;
    overflow: auto;

    .form-view {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: auto;

      .top {
        display: flex;
        align-items: center;

        .name {
          margin-right: .125rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }

        .sel-view {
          flex: 1;

          .el-select {
            width: 100%;
          }

          .el-icon-arrow-up:before {
            content: '\e78f';
          }
        }
      }
    }

    .bottom {
      margin-top: .2rem;
      flex: 1;
      width: 100%;
      overflow: auto;
      display: flex;

    }

    .bottom-cgq {
      justify-content: space-between;
      align-items: center;


      .left-view {
        width: 4.3875rem;
        height: 100%;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #E5E5E5;
        display: flex;
        flex-direction: column;
        overflow: auto;

        .header-view {
          height: .675rem;
          box-sizing: border-box;
          border-bottom: 1px solid rgba(241, 241, 241, 1);
          padding: 0 .125rem;
          display: flex;
          align-items: center;

          .el-input__inner {
            height: .45rem;
            line-height: .45rem;

          }

          .el-input__icon {
            cursor: pointer;
            line-height: .45rem !important;
          }
        }

        .tree-view {
          flex: 1;
          overflow: auto;
          margin: .1875rem .15rem;

          .custom-tree-node {
            flex: 1;

            .changespan {

              display: flex;
              justify-content: space-between;
              align-items: center;
              box-sizing: border-box;
              padding-right: .225rem;
            }

            .yuan {
              position: relative;
              width: .2rem;
              height: .2rem;
              box-sizing: border-box;
              background: #FFFFFF;
              border-radius: 50%;
              border: 1px solid #DBDBDB;
            }

            .yuan-ed {
              border-color: #2DAEA9;

              &::after {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                content: "";
                width: 0.1rem;
                height: .1rem;
                background: #2daea9;
                border-radius: 50%;

              }
            }


          }
        }
      }

      .icon-jt {
        width: .3875rem;
        height: .3125rem;
        background: url("~@/assets/image/cloudscene/icon-jt.png") no-repeat;
        background-size: 100% 100%;
      }

      .right-view {
        width: 4.3625rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .view {
          width: 4.3625rem;
          height: 2.3625rem;
          background: #FFFFFF;
          border-radius: 10px;
          border: 1px solid #E5E5E5;
          display: flex;
          flex-direction: column;

          .header-view {
            cursor: pointer;
            position: relative;
            display: flex;

            height: .675rem;
            box-sizing: border-box;
            border-bottom: 1px solid rgba(241, 241, 241, 1);

            .title {
              box-sizing: border-box;
              padding-left: .25rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: .2rem;
              color: #333333;
              display: flex;
              align-items: center;

              &::before {
                margin-right: .15rem;
                content: "";
                display: block;
                width: 3px;
                height: 15px;
                background: #2DAEA9;
              }
            }

            .yuan {
              position: absolute;
              top: 50%;
              right: .25rem;
              transform: translateY(-50%);

              width: .25rem;
              height: .25rem;
              background: #FFFFFF;
              border-radius: 50%;
              border: 1px solid #CCCCCC;
              box-sizing: border-box;
            }

            .yuan-ed {
              border-color: #2DAEA9;

              &::after {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                content: "";
                width: .1rem;
                height: .1rem;
                background: #2daea9;
                border-radius: 50%;

              }
            }
          }

          .con-view {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-sizing: border-box;
            padding: 0 18px;

            .label {
              margin-bottom: .2rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: 14px;
              color: #CCCCCC;
            }

            .input {}
          }
        }
      }
    }

    .bottom-ds {
      border-radius: 10px;
      border: 1px solid #E5E5E5;
      display: flex;
      flex-direction: column;

      .header-view {
        width: 100%;
        height: .7rem;
        border-bottom: 1px solid #E5E5E5;
        box-sizing: border-box;
        padding-left: .1875rem;
        display: flex;
        align-items: center;

        .label {
          margin-right: .1875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }
      }

      .cont-view {
        flex: 1;
        box-sizing: border-box;
        padding: .125rem;

        .con {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          border-radius: 10px;
          border: 1px solid #E5E5E5;
          overflow: hidden;
          display: flex;
          flex-direction: column;

          .timingtypeList {
            .item {
              cursor: pointer;
              height: .65rem;
              background: #F2F8F9;
              border-bottom: 1px solid #EEEEEE;
              box-sizing: border-box;
              padding: 0 .25rem;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .label {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #333333;
              }

              .yuan {
                position: relative;
                width: .25rem;
                height: .25rem;
                background: #FFFFFF;
                border-radius: 50%;
                border: 1px solid #CCCCCC;
                box-sizing: border-box;
              }

              .yuan-ed {
                border-color: #2DAEA9;

                &::after {
                  display: block;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translateX(-50%) translateY(-50%);
                  content: "";
                  width: .1rem;
                  height: .1rem;
                  background: #2daea9;
                  border-radius: 50%;

                }
              }
            }
          }

          .weeekList {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 .3rem;

            .item {
              user-select: none;
              cursor: pointer;
              width: .8875rem;
              height: .3375rem;
              border-radius: 5px;
              border: 1px solid #E5E5E5;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              overflow: hidden;

              .txt {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #454545;
                padding-left: .075rem;
                padding-right: .075rem;
              }

              .r-g {
                flex: 1;
                height: 100%;
                border-left: 1px solid #E5E5E5;
                background: #fafafa;
                display: flex;
                align-items: center;
                justify-content: center;

                .icon {
                  width: .2rem;
                  height: .2rem;
                  display: none;
                }
              }
            }

            .item-ed {
              border-color: #42B5B2;

              .r-g {
                border-color: #42B5B2;

                .icon {
                  display: block;
                }
              }
            }

            .item-no {
              cursor: not-allowed;
              pointer-events: none;
            }
          }
        }
      }
    }

    .bottom-kjhj {
      justify-content: space-between;
      align-items: center;

      .left-view {
        width: 4.3875rem;
        height: 100%;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #E5E5E5;
        display: flex;
        flex-direction: column;
        overflow: auto;

        .header-view {
          height: .675rem;
          box-sizing: border-box;
          border-bottom: 1px solid rgba(241, 241, 241, 1);
          padding: 0 .125rem;
          display: flex;
          align-items: center;

          .el-input__inner {
            height: .45rem;
            line-height: .45rem;

          }

          .el-input__icon {
            cursor: pointer;
            line-height: .45rem !important;
          }
        }

        .tree-view {
          flex: 1;
          overflow: auto;
          margin: .1875rem .15rem;

          .custom-tree-node {
            flex: 1;

            .changespan {

              display: flex;
              justify-content: space-between;
              align-items: center;
              box-sizing: border-box;
              padding-right: .225rem;
            }

            .yuan {
              position: relative;
              width: .2rem;
              height: .2rem;
              box-sizing: border-box;
              background: #FFFFFF;
              border-radius: 50%;
              border: 1px solid #DBDBDB;
            }

            .yuan-ed {
              border-color: #2DAEA9;

              &::after {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                content: "";
                width: 0.1rem;
                height: .1rem;
                background: #2daea9;
                border-radius: 50%;

              }
            }


          }
        }
      }

      .icon-jt {
        width: .3875rem;
        height: .3125rem;
        background: url("~@/assets/image/cloudscene/icon-jt.png") no-repeat;
        background-size: 100% 100%;
      }

      .right-view {
        width: 4.3875rem;
        height: 100%;
        box-sizing: border-box;
        border-radius: .125rem;
        border: 1px solid #E5E5E5;
        display: flex;
        flex-direction: column;

        .header-view {
          height: .675rem;
          box-sizing: border-box;
          border-bottom: 1px solid #E5E5E5;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 .125rem;

          .label {
            margin-right: .1rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }

          .sel {
            flex: 1;

            .el-select {
              width: 100%;
            }

            .el-icon-arrow-up:before {
              content: '\e78f';
            }
          }
        }

        .con-view {
          flex: 1;
          overflow: auto;
          box-sizing: border-box;
          padding: .15rem;

          .con-view-div {
            width: 100%;
            height: 100%;
            overflow: auto;

            .yuan {
              cursor: pointer;
              position: relative;
              width: .2rem;
              height: .2rem;
              box-sizing: border-box;
              background: #FFFFFF;
              border-radius: 50%;
              border: 1px solid #DBDBDB;
            }

            .yuan-ed {
              border-color: #2DAEA9;

              &::after {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                content: "";
                width: 0.1rem;
                height: .1rem;
                background: #2daea9;
                border-radius: 50%;

              }
            }

            .item {
              margin-bottom: .3rem;

              .title {
                display: flex;
                align-items: center;
                margin-bottom: .25rem;

                .label {
                  margin-left: .1rem;
                }
              }



              .el-input__suffix-inner {
                line-height: .5rem;
              }
            }

            .li {
              cursor: pointer;
              height: .5rem;
              display: flex;
              align-items: center;
              justify-content: space-between;
              box-sizing: border-box;
              padding: 0 .2rem;

              &:hover {
                background: #F3F7F8;
              }
            }
          }

          .noPLR {
            padding-left: 0;
            padding-right: 0;
          }
        }

        .con-view-no {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .table-emptyword {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }

    .bottom-gj {

      justify-content: space-between;
      align-items: center;

      .left-view {
        width: 4.3875rem;
        height: 100%;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #E5E5E5;
        display: flex;
        flex-direction: column;
        overflow: auto;

        .header-view {
          height: .675rem;
          box-sizing: border-box;
          border-bottom: 1px solid rgba(241, 241, 241, 1);
          padding: 0 .125rem;
          display: flex;
          align-items: center;

          .el-input__inner {
            height: .45rem;
            line-height: .45rem;

          }

          .el-input__icon {
            cursor: pointer;
            line-height: .45rem !important;
          }
        }

        .tree-view {
          flex: 1;
          overflow: auto;
          margin: .1875rem .15rem;

          .custom-tree-node {
            flex: 1;

            .changespan {

              display: flex;
              justify-content: space-between;
              align-items: center;
              box-sizing: border-box;
              padding-right: .225rem;
            }

            .yuan {
              position: relative;
              width: .2rem;
              height: .2rem;
              box-sizing: border-box;
              background: #FFFFFF;
              border-radius: 50%;
              border: 1px solid #DBDBDB;
            }

            .yuan-ed {
              border-color: #2DAEA9;

              &::after {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                content: "";
                width: 0.1rem;
                height: .1rem;
                background: #2daea9;
                border-radius: 50%;

              }
            }


          }
        }
      }

      .icon-jt {
        width: .3875rem;
        height: .3125rem;
        background: url("~@/assets/image/cloudscene/icon-jt.png") no-repeat;
        background-size: 100% 100%;
      }

      .gj-view {
        width: 4.3625rem;
        height: 100%;
        overflow: auto;

        .li-view {
          cursor: pointer;
          border-radius: 10px;
          border: 1px solid #E5E5E5;
          margin-top: .1125rem;

          &:nth-child(1) {
            margin-top: 0;
          }

          .header-view {
            cursor: pointer;
            position: relative;
            display: flex;

            height: .675rem;
            box-sizing: border-box;
            border-bottom: 1px solid rgba(241, 241, 241, 1);

            .title {
              box-sizing: border-box;
              padding-left: .25rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: .2rem;
              color: #333333;
              display: flex;
              align-items: center;

              &::before {
                margin-right: .15rem;
                content: "";
                display: block;
                width: 3px;
                height: 15px;
                background: #2DAEA9;
              }
            }

            .yuan {
              position: absolute;
              top: 50%;
              right: .25rem;
              transform: translateY(-50%);

              width: .25rem;
              height: .25rem;
              background: #FFFFFF;
              border-radius: 50%;
              border: 1px solid #CCCCCC;
              box-sizing: border-box;
            }

            .yuan-ed {
              border-color: #2DAEA9;

              &::after {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                content: "";
                width: .1rem;
                height: .1rem;
                background: #2daea9;
                border-radius: 50%;

              }
            }
          }

          .info-view {
            padding: .25rem .225rem;
            line-height: 1.5;
          }
        }
      }

      .gj-view-no {
        width: 4.3625rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .table-emptyword {
          margin-top: .25rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }
}
</style>